import * as React from 'react';

/**
 * Common interface for all custom SVG icons
 * Extends React SVGProps with common customization options
 */
export interface CustomIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon (width and height)
   * @default 24
   */
  size?: number | string;

  /**
   * Color of the icon
   * @default 'currentColor'
   */
  color?: string;

  /**
   * Additional className for styling
   */
  className?: string;
}

/**
 * Default props for custom icons
 */
export const defaultIconProps: Partial<CustomIconProps> = {
  size: 24,
  color: 'currentColor',
};
